import React, {useState} from 'react';
import {AppField} from "../../ui/AppField";
import {makeStyles} from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import DeleteIcon from '@mui/icons-material/Delete';
import {toast} from "react-toastify";
import cx from "classnames"
import {ApiEndPointFieldsProps} from "../../../constants/AppConstants";
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import AddIcon from '@mui/icons-material/Add';

const useStyles = makeStyles(() => ({
    fieldRoot: {
        display: "flex",
        gap: 10,
        margin: "10px 0"
    },
    fieldActionBtn: {
        height: "43px",
        width: "43px",
        background: "#F2F2F2",
        borderRadius: 8,
        overflow: "hidden",
        cursor: "pointer",
        transition: "0.3s",
        "&:hover": {
            transform: "scale(1.1)"
        }
    },
    btn: {
        display: "flex",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
    },
}));

interface Props {
    readonly item: any
    readonly onAdd: (item: ApiEndPointFieldsProps) => void
    readonly onDelete: (id: number) => void
    readonly addField?: boolean
    readonly onUpdate: (id: number, data:ApiEndPointFieldsProps) => void
}

export function IntegrationApiOptionsFieldItem({item, onAdd, addField,onDelete,onUpdate}: Props) {
    const classes = useStyles();

    const [reallyDelete, setReallyDelete] = useState(false);
    const [changed, setChanged] = useState(false);
    const [values, setValues] = useState(item ?? {
        code: "",
        value: "",
        saved: false,
    });

    const handleChange = (name: string, value: string) => {
        setValues((prev: ApiEndPointFieldsProps) => ({
            ...prev,
            [name]: value
        }))
    };
    return (
        <div className={cx(classes.fieldRoot)}>
            <AppField name="code" placeholder="code" value={values.code}
                      onChange={(e: any) => {
                          handleChange("code", e.target.value);
                          if (item.saved) {
                              setChanged(true)
                          }
                      }}/>
            <AppField name="value" placeholder="value" value={values.value}
                      onChange={(e: any) => {
                          handleChange("value", e.target.value);
                          if (item.saved) {
                              setChanged(true)
                          }
                      }}/>
            <div className={classes.fieldActionBtn}>
                {
                        changed ? (
                            <div
                                className={classes.btn}
                                onClick={() => {
                                    if (Boolean(values.code)) {
                                        onUpdate(item.id, values);
                                        setChanged(false)
                                    }else {
                                        toast.error("Please fill in both fields")
                                    }
                                }}
                            >
                               <ChangeCircleIcon color="success"/>
                            </div>
                        ) : (
                            <div
                                className={classes.btn}
                                onClick={() => {
                                    if (reallyDelete) {
                                        onDelete(item.id);
                                    } else {
                                        setReallyDelete(true)
                                    }
                                }}
                            >
                                {reallyDelete ? <DeleteIcon color="error"/> : <CloseIcon/>}
                            </div>
                    )
                }
            </div>
        </div>
    );
}

